import { createContext } from "react";
import useAuth from "../hooks/useAuth.js";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
    const { login, authenticated, logout } = useAuth();

    return (
        <UserContext.Provider value={{ login, authenticated, logout }}>
            {children}
        </UserContext.Provider>
    );
};

const UserContextModule = { UserContext, UserProvider };

export default UserContextModule;